import React, { useEffect, useState, useCallback, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import axios from "axios";
import DataTable from "react-data-table-component";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext";
import { toast, ToastContainer } from "react-toastify";
import RequestModal from "../components/RequestModal";
import LoaderHomePd from "../components/loaderHomePd";

const ExhibitionLive = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [wishlists, setWishlists] = useState([]);
  const { wishlist, addToWishlist } = useContext(CartContext);
  const { currencyContxt } = useContext(CurrencyContext); // Use context
  const [loading, setLoading] = useState(true);

  const [newdataLive, setNewdataLive] = useState({
    id: "0",
    exhibitionTitle: "",
    dateStart: new Date(),
    dateEnd: new Date(),
    exhibitionDate: "",
    description: "",
  });
  const [newdataArtworks, setNewdataArtworks] = useState([]);
  const [newdataArtworks2, setNewdataArtworks2] = useState([]);

  // Preprocess data to group artworks by artist
  const groupArtworksByArtist = (artworks, shuffleOnly = false) => {
    // Shuffle function
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };

    // If shuffleOnly is true, just shuffle the input and return
    if (shuffleOnly) {
      return shuffleArray(artworks);
    }

    // Group artworks by artist
    const groupedData = artworks.reduce((acc, item) => {
      const { artistID, artistName, imageURLArtist, imageURLArtwork, productTitle } = item;

      if (!acc[artistID]) {
        acc[artistID] = {
          artistID,
          artistName,
          imageURLArtist,
          artworks: [],
        };
      }
      acc[artistID].artworks.push({
        imageURLArtwork,
        productTitle,
      });

      return acc;
    }, {});

    // Convert object back to an array and shuffle the grouped data
    const groupedArray = Object.values(groupedData);
    return shuffleArray(groupedArray);
  };

  const fetchExhibitionDetails = useCallback(async () => {
    try {
      const [responseLive, responseArtworks] = await Promise.all([
        axios.get(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionLiveDetailsByExhibitionID?exhibitionID=${id}`),
        axios.get(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionLiveArtworkDetailsByExhibitionID?exhibitionID=${id}`),
      ]);

      // Update Live Exhibition Data
      if (responseLive.data) {
        const dataLive = responseLive.data;
        setNewdataLive({
          ...newdataLive,
          id: dataLive.id,
          exhibitionTitle: dataLive.exhibitionTitle,
          exhibitionDate: dataLive.exhibitionDate,
          description: dataLive.description,
        });
      }

      // Update Upcoming Exhibitions Data
      if (responseArtworks.data) {
        setLoading(true);
        const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
        await delay;

        // Set only shuffled data
        const shuffledArtworks = groupArtworksByArtist(responseArtworks.data, true);
        setNewdataArtworks2(shuffledArtworks);

        // Set grouped and shuffled data
        const groupedAndShuffledArtworks = groupArtworksByArtist(responseArtworks.data);
        setNewdataArtworks(groupedAndShuffledArtworks);
      }
    } catch (error) {
      console.error("Error fetching exhibition details:", error);
    }
  }, []);

  useEffect(() => {
    fetchExhibitionDetails();
  }, [fetchExhibitionDetails]);

  const columns = [
    {
      cell: (row) => {
        const isInWishlist = wishlists.some(item => item.productID === row.productID);
        return (
          <div className="pd_item" key={row.productID}>
            <div className="img_box">
              <img src={`../../../images/products/thumbnail/${row.imageURLArtwork}`} className="pd_img" alt="" />
              <a href="#" className="wishlist_link" title="WISHLIST" onClick={async (e) => {
                e.preventDefault();
                //addToWishlist(row); // Add or remove item from wishlist
                handleWishlistClick(row); // Updated function                               

              }}>
                <i className={`${isInWishlist ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
              </a>
              <span className="q_view" onClick={() => handleDetails(row.productID, row.productTitle)}>
                <i className="bi bi-eye"></i> Quick View
              </span>
              <span className="size">Size: <b>{row.size}</b></span>
            </div>
            <div className="pd_content">
              <span className="pd_brand">{row.productTitle}</span>
              <span className="pd_title">{row.category}: {row.categoryType}</span>
              <span className="pd_title">Art by:
                <span className="btn_artist1" onClick={() => handleArtist(row.artistID, row.artistName)}>
                  {row.artistName}
                </span>
              </span>
              {
                row.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row.product_id, row.productTitle)}>Request Price</span></> :

                  <div className="Price">
                    {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                    {
                      row.discountRate === 0 ? ''
                        : <>
                          <span className="old_price">{currencyContxt.icon} {((row.gstMRP) / currencyContxt.value).toFixed(2)}</span><span className="discount">({row.discountRate}%)</span>
                        </>
                    }
                    {
                      currencyContxt.currency == "INR" ?
                        <small>Including GST</small>
                        :
                        <></>
                    }
                  </div>
              }

            </div>
          </div>
        );
      }
    },
  ];


  //Wishlist Click
  const userInfo = JSON.parse(localStorage.getItem('user-info'));
  // Fetch the wishlist data when the page loads
  const fetchWishlistData = async () => {

    if (userInfo && userInfo.buyer_id) {
      try {
        const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const wishlistData = await response.json();

        if (wishlistData && Array.isArray(wishlistData)) {
          setWishlists(wishlistData); // Store complete wishlist items from API
        } else {
          setWishlists([]); // Set an empty wishlist if no data is returned
        }

      } catch (error) {
        console.error('Error fetching wishlist:', error);
      }
    } else {
      const localWishlist = getWishlistFromLocalStorage();
      setWishlists(localWishlist); // Store complete wishlist items from local storage
    }
  };

  // Handler for Wishlist Button Click
  const handleWishlistClick = async (item) => {

    const itemIsInWishlist = isInWishlist(item.product_id);

    if (userInfo && userInfo.buyer_id) {

      try {
        const payload = {
          customer_id: userInfo.buyer_id,
          product_id: item.product_id,
        };
        const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`Failed to update wishlist: ${response.statusText}`);
        }

        // Extract JSON data from the response
        const { action } = await response.json(); // Destructuring to get action flag


        // Display success message based on the action performed
        if (action === "Add") {
          toast.success("Artwork Added to Wishlist !!");
        } else if (action === "Remove") {
          toast.error("Artwork Removed from Wishlist !!");
        }
        // Fetch the updated wishlist after modification
        await fetchWishlistData();  // Refresh state with the updated wishlist from the database
      } catch (error) {
        console.error("Error syncing wishlist item:", item.product_id, error);
      }
    }
    else {
      if (itemIsInWishlist) {
        // Remove from wishlist logic
        removeFromWishlist(item.product_id);
        toast.error("Artwork Removed from Wishlist 2 !!");
      } else {
        addToWishlist(item);
        toast.success("Artwork Added to Wishlist !!");
      }
    }


    handleWishlistUpdate(); // Refresh wishlist state after adding/removing
  };

  // Helper function to get wishlist from localStorage
  const getWishlistFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  };

  // Context or state management function
  const handleWishlistUpdate = () => {

    if (userInfo && userInfo.buyer_id) {
      fetchWishlistData(); // Fetch from API
    } else {
      const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
      setWishlists(updatedWishlist); // Update state
    }
  };
  const isInWishlist = (productId) => {
    return wishlists.some(item => item.product_id === productId);
  };

  // Function to remove item from the wishlist
  const removeFromWishlist = (productId) => {
    const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
    setWishlists(updatedWishlist); // Update state
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
  };

  useEffect(() => {
    const loadWishlist = async () => {
      await fetchWishlistData();
    };
    loadWishlist();
  }, []);
  useEffect(() => {
    setWishlists(wishlist);
  }, [wishlist]); // This will trigger every time the wishlist state changes


  //WishList Click ends

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedPd, setSelectedPd] = useState(null);

  const handleRequestPrice = (id, pdTitle) => {
    setModalOpen(true);
    setSelectedId(id);
    setSelectedPd(pdTitle);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedId(null);
    setSelectedPd(null);
  };

  const handleExbDetails = (exhibitionID, artistID) => {
  
    
    navigate(`/exhibitionDetails/${exhibitionID}-${artistID}`);
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  const handleDetails = (id, productTitle) => {
    const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
    navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id } });
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  const handleArtist = (artistId, artistName) => {
    const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
    navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId } });
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  return (
    <>
      <Header />
      <div style={{ marginTop: "150px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <h2 className="sec_title">
                Welcome to IndiGalleria's Online Art Exhibition
              </h2>
              <h3 style={{ textAlign: "center" }}>
                A virtual art show by Well-Known and Upcoming Indian Artists
              </h3>
            </div>
          </div>
          <div className="col-md-12 pd-list">

            <div className="artistgrid">
              {newdataArtworks.map((artist, index) => (
                <div key={index} className="artistgimg">
                  <img 
                      src={`../../../images/artist/thumbnail/${artist?.imageURLArtist}`} 
                      alt={`Artist ${index + 1}`} 
                      onClick={() => handleExbDetails(newdataLive.id, artist?.artistID)}
                      />
                  <span 
                      className="artistgname" 
                      onClick={() => handleArtist(artist?.artistID, artist?.artistName)}
                      style={{ cursor: "pointer" }}
                  >
                    {artist?.artistName}
                  </span>
                </div>
              ))}
            </div>

          </div>
          <div className="col-md-12 pd-list">
            <DataTable
              columns={columns}
              data={newdataArtworks2}

              noTableHead
            />
          </div>
        </div>
      </div>
      <Footer />
    </>

  );

};
export default ExhibitionLive;